var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumberShape = function SvgNumberShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7555_7545)",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M24.536 3.121a5 5 0 0 0-7.071 0L3.12 17.465a5 5 0 0 0 0 7.07L17.465 38.88a5 5 0 0 0 7.07 0L38.88 24.536a5 5 0 0 0 0-7.071z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7555_7545",
    x1: 21,
    x2: 21,
    y1: 12.144,
    y2: 39.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2030"
  })))));
};
export default SvgNumberShape;